import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

Vue.use(Vuex)

const state = {
  position:{},//之前页面位置
  arrPageName:'index',//当前页面NAME
  username:'',//用户姓名
  permissions:[],//权限数组
  navbarIndex:-1,
  pageInfo:{},//页面搜索信息
}

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
})



// WEBPACK FOOTER //
// ./src/story/index.js